/**
 * config amdin url here
 */

 const isPrd = process.env.NODE_ENV === 'production'

 const loginUrl = isPrd ? 'http://oms.aybases.com/#/login' : 'http://service.quartzx.com:9005/#/login'

 const isPrdSite =  location.origin === 'http://service.quartzx.com'

 export {
   loginUrl, isPrd,isPrdSite
   
 }
 